import { EventForm } from "components/events";
import {
  useQueryEvent,
  useQueryTags,
  useQueryOrganizerVenues,
} from "hooks/events";
import { useQueryOrganizers } from "hooks/organizers";
import { usePreDownload } from "hooks/usePreDownload";
import { useQueryCurrentUser } from "hooks/users";
import { useQueryVenues } from "hooks/venues";
import { useParams } from "react-router-dom";

export const DuplicateEvent = () => {
  const { uid } = useParams();
  const currentUserQuery = useQueryCurrentUser();
  const organizerId = currentUserQuery.user?.organizer_id;
  const organizerVenues = useQueryOrganizerVenues(organizerId);

  const {
    isLoading,
    isError,
    error,
    organizers,
    venues,
    event,
    tags,
    currentUser,
  } = usePreDownload([
    { hookName: "event", hook: useQueryEvent({ uid: uid! }) },
    {
      hookName: "organizers",
      hook: useQueryOrganizers({ page: 1, perPage: 1000 }),
    },
    { hookName: "venues", hook: useQueryVenues({}) },
    { hookName: "tags", hook: useQueryTags() },
    { hookName: "currentUser", hook: useQueryCurrentUser() },
  ]);

  if (isLoading || currentUserQuery.isLoading || organizerVenues.isLoading) {
    return null;
  }
  if (isError) {
    return (
      <div>
        Something went wrong:
        {error?.message}
      </div>
    );
  }
  return (
    <EventForm
      isNew
      event={event.event}
      venues={venues?.venues || []}
      organizers={
        organizers?.organizers.map((organizer: any) => ({
          id: organizer.id,
          name: organizer.name,
        })) || []
      }
      tags={tags.tags || []}
      currOrganizerId={currentUser.user.organizer_id}
      organizerVenues={organizerVenues.data}
    />
  );
};
